/** simple types */
import ConcatCell from '../../datatable/templates/ConcatCell.vue';
/** specific array values */
import ContractActionByDateCell from '../../datatable/templates/ContractActionByDateCell.vue';
import CostInvoiceItemStatusBadgeCell from '../../datatable/templates/CostInvoiceItemStatusBadgeCell.vue';
import CustomerGroupArrayCell from '../../datatable/templates/CustomerGroupArrayCell.vue';
import CustomerGroupCell from '../../datatable/templates/CustomerGroupCell.vue';
import DateArrayCell from '../../datatable/templates/DateArrayCell.vue';
import DateArrayCellCollapsible from '../../datatable/templates/DateArrayCellCollapsible.vue';
/** arrays */
import InvoiceNameOrIdCell from '../../datatable/templates/InvoiceNameOrIdCell.vue';
import InvoiceSource from '../../datatable/templates/InvoiceSource.vue';
import Megabyte from '../../datatable/templates/Megabyte.vue';
import MimetypeCell from '../../datatable/templates/MimetypeCell.vue';
import ObjectArrayCell from '../../datatable/templates/ObjectArrayCell.vue';
import ObjectCell from '../../datatable/templates/ObjectCell.vue';
import PartnerGroupCell from '../../datatable/templates/PartnerGroupCell.vue';
import PartnersArrayCell from '../../datatable/templates/PartnersArrayCell.vue';
import PointOfSalesCell from '../../datatable/templates/PointOfSalesCell.vue';
/** specific simple values */
import ProcessNameBadgeCell from '../../datatable/templates/ProcessNameBadgeCell.vue';
import RelatedTicketCell from '../../datatable/templates/RelatedTicketCell.vue';
import SfmChildPositionArrayCell from '../../datatable/templates/SfmChildPositionArrayCell.vue';
import SignatureArrayCell from '../../datatable/templates/SignatureArrayCell.vue';
import SimpleConnectEnumArrayCell from '../../datatable/templates/SimpleConnectEnumArrayCell.vue';
import StringArrayCell from '../../datatable/templates/StringArrayCell.vue';
import StringCell from '../../datatable/templates/StringCell.vue';
import TicketStatusBadgeCell from '../../datatable/templates/TicketStatusBadgeCell.vue';
import TicketStatusPaginatedBadgeCell from '../../datatable/templates/TicketStatusPaginatedBadgeCell.vue';
import ContractActionArrayCell from '../templates/ContractActionArrayCell.vue';
import ContractAreasArrayCell from '../templates/ContractAreasArrayCell.vue';
import ContractClausesArrayCell from '../templates/ContractClausesArrayCell.vue';
import ContractContactPersonsArrayCell from '../templates/ContractContactPersonsArrayCell.vue';
import ContractPartnersArrayCell from '../templates/ContractPartnersArrayCell.vue';
import ContractPaymentsArrayCell from '../templates/ContractPaymentsArrayCell.vue';
import DateCell from '../templates/DateCell.vue';
import EnumArrayCell from '../templates/EnumArrayCell.vue';
import CustomersArrayCell from '../templates/PaginatedCustomersArrayCell.vue';
import PhoneCell from '../templates/PhoneCell.vue';

export const TemplateComponents = {
  attachments: StringCell,
  concatString: ConcatCell,
  contractActionArray: ContractActionArrayCell,
  contractActionByDate: ContractActionByDateCell,
  contractAreasArray: ContractAreasArrayCell,
  contractClausesArray: ContractClausesArrayCell,
  contractContactPersonsArray: ContractContactPersonsArrayCell,
  contractPartnersArray: ContractPartnersArrayCell,
  contractPaymentsArray: ContractPaymentsArrayCell,
  costInvoiceItemStatusBadge: CostInvoiceItemStatusBadgeCell,
  customerGroup: CustomerGroupCell,
  customerGroupArray: CustomerGroupArrayCell,
  customers: CustomersArrayCell,
  dateArray: DateArrayCell,
  dateArrayCollapsible: DateArrayCellCollapsible,
  dateCell: DateCell,
  default: StringCell,
  enumArray: EnumArrayCell,
  invoiceNameOrIdCell: InvoiceNameOrIdCell,
  invoiceSource: InvoiceSource,
  megabyte: Megabyte,
  mimetype: MimetypeCell,
  object: ObjectCell,
  objectArray: ObjectArrayCell,
  partnerGroup: PartnerGroupCell,
  partners: PartnersArrayCell,
  phoneCell: PhoneCell,
  pos: PointOfSalesCell,
  processNameBadge: ProcessNameBadgeCell,
  relatedTicket: RelatedTicketCell,
  sfmChildPositionArray: SfmChildPositionArrayCell,
  signatureArray: SignatureArrayCell,
  simpleConnectEnumArray: SimpleConnectEnumArrayCell,
  stringArray: StringArrayCell,
  strings: StringCell,
  ticketStatusBadge: TicketStatusBadgeCell,
  ticketStatusPaginatedBadge: TicketStatusPaginatedBadgeCell,
};

export type AssignableTemplateNames = keyof typeof TemplateComponents;
